import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ENDPOINTS, getApiUrl } from "../../../common/endpoints";
import { Requests } from "../../../common/requests";
import { CARD_IMG_URL } from "../../../constants";
import { Visibility } from "@mui/icons-material";
import CardDialog from "./CardDialog";
const ListCards = ({ suidId }: { suidId: string }) => {
  const [cards, setCards] = useState([]);
  const [cardDetail, setCardDetail] = useState<any>(null);
  useEffect(() => {
    fetchSuit();
  }, []);

  const fetchSuit = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.TAROT_GET_ONE_SUIT.replace(":id", suidId)
    );
    try {
      const data = await Requests.get(apiUrl);
      if (Array.isArray(data.cards)) {
        setCards(data.cards);
      }
    } catch (e) {}
  };

  const handleClose = () => {
    setCardDetail(null);
  };

  return (
    <>
      <List>
        {cards.map((card: any) => (
          <ListItem key={card.id}>
            <img
              src={CARD_IMG_URL.replace("CARD_ID", card.id)}
              alt={card.title}
              style={{ width: "30px", marginRight: "10px" }}
            />
            <ListItemText primary={card.title} />
            <IconButton sx={{}} onClick={() => setCardDetail(card)}>
              <Visibility />
            </IconButton>
          </ListItem>
        ))}
      </List>
      {cardDetail && <CardDialog card={cardDetail} handleClose={handleClose} />}
    </>
  );
};

export default ListCards;
